import { Toast, Dialog } from 'vant';
import Router from '@/router';
import { PackageStatusType } from '@/model/PackageStatusType';
import { PcidType } from '@/model/PcidType';
import { exitPage } from '@/utils/bridge.js';
import { track } from '@/directives/track/send.js';
import CustomeDialog from '@/components/telecomConfirmDialog';
import { deeplinkto, parseUrlParams, serializeUrlParams } from '@/utils/index';
import ProcessDialog from '@/components/processDialog';
import { addtoneFree, conflictPkgTelecom, packageList, unsubscribeTelecom } from '@/api/modules/telecom';
import { HeaderType } from '@/model/HeaderType';
import { CarrierType } from '@/model/CarrierType';
const sensors = window.sensorsDataAnalytic201505;
export const handleMIGUClose = (dom, videoInstance, currentPlay, context) => {
    const { commit, state, rootState } = context;
    if (dom && dom.style) {
        if (Router.currentRoute.query.header_type !== HeaderType.HideHeader) {
            if (Router.currentRoute.query.header_type === HeaderType.Header) {
                dom.style.top =
                    Router.currentRoute.query.status_height !== undefined
                        ? Number(Router.currentRoute.query.status_height) + 'px'
                        : '32px';
                dom.style.background = 'white';
            }
        }
        dom.style.zIndex = '2000';
    }
    const processDialog = window.document.querySelector('#process-dialog');
    // 拦截手势和返回键,收起咪咕订阅弹窗
    if (window.bridge) {
        if (window.bridge.notifyDialogVisible) {
            window.bridge.notifyDialogVisible(true);
        }
        window.onBackPressed = () => {
            const miguPopup = window.document.querySelector('#imusicTag');
            if (miguPopup) {
                if (miguPopup.style.display === 'block') {
                    ProcessDialog.close();
                    Toast.clear();
                    miguPopup.style.display = 'none';
                    commit('SET_HAS_CANCEL_ORDER', true);
                    const temData = JSON.parse(JSON.stringify(state.settingData));
                    commit('SET_RETENTION_ORDER_PARAMS', { ...temData, sourceType: state.carrierType, phone: state.phone });
                    if (!rootState.app.loginStatus) {
                        commit('app/SET_USERINFO', {}, { root: true });
                        // commit('SET_PHONE', '')
                    }
                    commit('SET_STATUSDIV', false);
                    // 挽留弹窗
                    commit('SET_OPEN_RETENTION', true);
                    Dialog.alert({ message: '用户取消支付', showConfirmButton: false, className: 'failed-dialog' });
                    setTimeout(() => {
                        Dialog.close();
                    }, 2000);
                }
            }
        };
    }
    const observer = new MutationObserver(function (mutations, observer) {
        mutations.forEach(function (mutationRecord) {
            // 获取监听的dom节点中style为display的值赋予loading
            if (mutationRecord.target instanceof HTMLElement && mutationRecord.target.style) {
                const value = mutationRecord.target.style.getPropertyValue('display');
                // 只有进度条消失 且 display变为none 判定是migu订单弹窗收起
                if (value === 'none' && processDialog && processDialog.style.display === 'none') {
                    if (currentPlay && videoInstance?.play) {
                        videoInstance?.play();
                    }
                    observer.disconnect();
                }
                else if (value === 'block') {
                    // 此过程拉起订购页
                    videoInstance?.pause && videoInstance?.pause();
                    ProcessDialog.close();
                    Toast.clear();
                    track([{ event_id: 'h5_color_ring_link_order_page_success', event_param: { content_name: CarrierType.ENUM[state.carrierType], carrier_name: CarrierType.ENUM[state.carrierType] } }]);
                }
            }
        });
    });
    dom && observer.observe(dom, { attributes: true, attributeFilter: ['style'] });
};
export const actions = {
    getPackageList({ dispatch, rootState }, payload) {
        // dispatch('checkMobileTrack', { type: '26', res: '', isSuccess: false, carrierName: CarrierType.TELECOM })
        // dispatch('handleActionApi', {
        //   isp: CarrierType.ENUM[CarrierType.TELECOM],
        //   token: rootState.app.userInfo.TOKEN,
        //   phone: rootState.app.userInfo.phone,
        //   action: '26',
        //   interfaceName: '/api/telecom/package/list',
        //   resCode: '',
        //   resMessage: ''
        // })
        return new Promise((resolve, reject) => {
            packageList(payload)
                .then((res) => {
                dispatch('checkMobileTrack', {
                    type: '27',
                    res,
                    isSuccess: res.code === '0000',
                    carrierName: CarrierType.TELECOM
                });
                dispatch('handleActionApi', {
                    isp: CarrierType.ENUM[CarrierType.TELECOM],
                    token: rootState.app.userInfo.TOKEN,
                    phone: rootState.app.userInfo.phone,
                    action: '27',
                    interfaceName: '/api/telecom/package/list',
                    resCode: res.code,
                    resMessage: JSON.stringify(res)
                });
                resolve(res);
            })
                .catch((err) => {
                reject(err);
            });
        });
    },
    // 电信订阅
    async orderTelecom({ commit, state, dispatch, rootState }, payload) {
        let isCurrentPageSetting = false;
        let openOrder = false;
        let openNew = false;
        let isNoComfirn = false;
        if (payload) {
            isCurrentPageSetting = payload.isCurrentPageSetting;
            openOrder = !!payload.openOrder;
            openNew = !!payload.openNew;
            isNoComfirn = !!payload.isNoComfirn;
        }
        Toast.clear();
        Toast.loading({ forbidClick: true, duration: 1500 });
        const mobile = state.phone;
        const curerntPageParams = parseUrlParams(location.href);
        curerntPageParams.videoId = state.settingData.videoId;
        curerntPageParams.copyRightID = state.settingData.copyRightID;
        curerntPageParams.productId = state.settingData.productId;
        const returnUrl = window.location.href.split('?')[0] + '?' + serializeUrlParams(curerntPageParams);
        const isRingIdEmpty = (!state.settingData.videoId); // 彩铃id是否为空
        const isCorrectId = state.settingData.videoId && (state.settingData.videoId.length !== 12); // 彩铃id是否是移动id
        if (((isRingIdEmpty || isCorrectId)) && rootState.app.configData.backup_ringid_telecom) {
            const backupid = rootState.app.configData.backup_ringid_telecom;
            const backupproductid = '135999999999999000351';
            commit('SET_SETTING_VIDEOID', backupid);
            commit('SET_SETTING_PRODUCT_ID', backupproductid);
            curerntPageParams.videoId = backupid;
            curerntPageParams.productId = backupproductid;
            const clickTrackParam2 = {
                content_id: state.settingData.videoId,
                content_name: state.settingData.desc,
                $element_content: '设为彩铃（内容）',
                $element_id: 'next-step',
                $element_type: 'div'
            };
            clickTrackParam2.content_id = backupid + '(空)';
            clickTrackParam2.content_name = '(空)';
            track([{ event_id: '$WebClick', event_param: clickTrackParam2 }]);
        }
        await dispatch('user/getUserToken', { phone: state.phone, type: CarrierType.TELECOM }, { root: true });
        if (Router.currentRoute.query.tabType === 'tab-home') {
            // window.close()
            const query = {
                phone: state.phone,
                token: rootState.app.userInfo.TOKEN,
                carrierType: state.carrierType,
                sourceChange: true,
                loginStatus: rootState.app.loginStatus,
                date: new Date().getTime()
            };
            window.localStorage.setItem('tag-home-fresh', JSON.stringify(query));
        }
        dispatch('getPackageList', state.phone).then((res) => {
            const presetProperties = sensors.getPresetProperties();
            const cookieId = presetProperties.identities.$identity_cookie_id;
            // 判断是否又订购包或者旧包
            let status = null;
            let settingPackageId = '135999999999999000565';
            const packageId = state.settingData.productId;
            res.data?.forEach((element) => {
                if (element.package_id === packageId) {
                    status = element.status;
                    if (status === PackageStatusType.Subscribed) {
                        settingPackageId = '135999999999999000565';
                    }
                }
            });
            // 进一步判断旧包存在不
            const hasOtherPruduct = false;
            const oldid = '135999999999999000351';
            if (status !== PackageStatusType.Subscribed) {
                res.data?.forEach((element) => {
                    if (element.package_id === oldid) {
                        status = element.status;
                        if (status === PackageStatusType.Subscribed) {
                            settingPackageId = '135999999999999000351';
                        }
                    }
                });
            }
            if ((status === PackageStatusType.Subscribed || hasOtherPruduct)) {
                // 1.一键登录的手机号是当前使用的 手机号则不需要验证码
                // 2.没确认登陆但是已经书输入过验证码
                // 3.已经确认登录 则不需要验证码
                if ((state.oneClickPhone && state.oneClickPhone === state.phone) ||
                    (rootState.app.codeValidate &&
                        !rootState.app.loginStatus &&
                        JSON.stringify(rootState.app.userInfo) !== '{}') ||
                    rootState.app.loginStatus) {
                    // 未确认登录需要 输入验证码后确认
                    const phoneNumber = state.phone;
                    const toneCode = state.settingData.videoId;
                    addtoneFree({
                        phoneNumber,
                        toneCode,
                        packageId: settingPackageId,
                        promotionChannel: Router.currentRoute.query.pcid,
                        pid: rootState.app.selfInfo['dev-pid'],
                        uid: rootState.app.selfInfo.uid,
                        cookieId: cookieId
                    })
                        .then((res) => {
                        dispatch('checkMobileTrack', {
                            type: '30',
                            res,
                            isSuccess: res.code === '0000',
                            carrierName: CarrierType.TELECOM
                        });
                        dispatch('handleActionApi', {
                            isp: CarrierType.ENUM[CarrierType.TELECOM],
                            token: rootState.app.userInfo.TOKEN,
                            phone: rootState.app.userInfo.phone,
                            action: '30',
                            interfaceName: '/telecom/addtone/free',
                            resCode: res.code,
                            resMessage: JSON.stringify(res)
                        });
                        Toast.clear();
                        if (res.code === '0000') {
                            window.localStorage.setItem('userInfo', JSON.stringify(rootState.app.userInfo));
                            commit('SET_PHONE', phoneNumber);
                            commit('app/SET_LOGIN_STATUS', true, { root: true });
                            dispatch('loginConfirm');
                            Toast.success({
                                message: '设置成功',
                                forbidClick: true,
                                duration: 1500,
                                onClose: () => {
                                    if (Router.currentRoute.query.tabType === 'tab-home') {
                                        exitPage();
                                    }
                                    if (!isCurrentPageSetting) {
                                        const pageCount = state.historyPage.length ? state.historyPage.length : 1;
                                        if (Router.currentRoute.query.order_no) {
                                            Router.go(-(pageCount + 3)); // 电信订购成功之后直接跳回我们页面。此时订购成功回退的时候需要多回跳2个页面
                                        }
                                        else {
                                            Router.go(-pageCount);
                                        }
                                    }
                                }
                            });
                        }
                        else {
                            if (res.message === '用户不存在') {
                                Dialog.alert({
                                    title: '温馨提示',
                                    message: '抱歉，您的视频彩铃功能未开通。请先在应用商店下载【爱音乐】app，然后在【我的】-【会员中心】开通功能。',
                                    confirmButtonText: '我知道了',
                                    className: 'telecom-msg sendMsg-dialog '
                                });
                            }
                            else {
                                Toast.fail({
                                    message: res.message || '设置失败',
                                    forbidClick: true,
                                    duration: 1500
                                });
                            }
                        }
                        window.localStorage.removeItem('productId');
                    })
                        .catch((err) => {
                        dispatch('handleActionApi', {
                            isp: CarrierType.ENUM[CarrierType.TELECOM],
                            token: rootState.app.userInfo.TOKEN,
                            phone: rootState.app.userInfo.phone,
                            action: '31',
                            interfaceName: '/telecom/addtone/free',
                            resCode: 'err',
                            resMessage: JSON.stringify(err)
                        });
                    });
                }
                else {
                    const query = {
                        ...Router.currentRoute.query,
                        ...state.settingData
                    };
                    if (Number(Router.currentRoute.query.status_height) > 0) {
                        query.status_height = Router.currentRoute.query.status_height;
                    }
                    if (openNew) {
                        delete query.status_height;
                        delete query.header_type;
                        query.tabType = 'tab-home';
                        deeplinkto('/verification-code', query);
                    }
                    else {
                        Router.push({
                            name: 'verification-code',
                            query,
                            params: {
                                isPush: 'true'
                            }
                        });
                    }
                }
            }
            else {
                if ((Router.currentRoute.name !== 'backup-cw') && ((isCurrentPageSetting &&
                    !state.sourceChange &&
                    !!(window.KuYinExt && window.KuYinExt.requestAuthorizationAs) &&
                    !openOrder && !(PcidType.Apps.includes(Router.currentRoute.query.pcid)) && (rootState.appStore.showDetailStyle !== 'b')) ||
                    ((Router.currentRoute.name !== 'inputphone-oneclick' && rootState.app.processConfig[2].page) && !isNoComfirn && !(PcidType.Apps.includes(Router.currentRoute.query.pcid)) && (rootState.appStore.showDetailStyle !== 'b'))) // 播放渠道搜索渠道 并且播放样式不是b
                ) {
                    const query = {
                        ...Router.currentRoute.query,
                        ...state.settingData
                    };
                    if (Number(Router.currentRoute.query.status_height) > 0) {
                        query.status_height = Router.currentRoute.query.status_height;
                    }
                    if (openNew) {
                        delete query.header_type;
                        delete query.status_height;
                        query.tabType = 'tab-home';
                        if (rootState.app.configData.tab_home_setting_page === '1') {
                            deeplinkto('/details', query, '0');
                            return;
                        }
                        deeplinkto('/inputphone-oneclick', query);
                    }
                    else {
                        Router.push({
                            name: 'inputphone-oneclick',
                            query,
                            params: {
                                isPush: 'true'
                            }
                        });
                    }
                }
                else {
                    // 没有定
                    if (rootState.app.processConfig[1].dialog) {
                        CustomeDialog({
                            phone: state.phone,
                            rules: rootState.app.processConfig[1].rules,
                            title: rootState.app.configData.telecom_dialog_title,
                            actorName: state.settingData.actorName,
                            songName: state.settingData.songName
                        })
                            .then(() => {
                            conflictPkgTelecom({
                                phoneNumber: state.phone,
                                packageId: '135999999999999000565'
                            })
                                .then(res => {
                                if (res.code === '0000') {
                                    if (res.data.code === '0') {
                                        dispatch('openOrder', {
                                            mobile,
                                            returnUrl,
                                            cookieId,
                                            video: payload.video,
                                            currentPlay: payload.currentPlay
                                        });
                                    }
                                    else {
                                        Toast.fail({
                                            message: res.data.describe,
                                            forbidClick: true,
                                            duration: 1500
                                        });
                                    }
                                }
                                else {
                                    Toast.fail({
                                        message: res.message,
                                        forbidClick: true,
                                        duration: 1500
                                    });
                                }
                            });
                        }).catch(err => {
                            console.log(err);
                        });
                    }
                    else {
                        conflictPkgTelecom({
                            phoneNumber: state.phone,
                            packageId: '135999999999999000565'
                        })
                            .then(res => {
                            if (res.code === '0000') {
                                if (res.data.code === '0') {
                                    dispatch('openOrder', {
                                        mobile,
                                        returnUrl,
                                        cookieId,
                                        video: payload.video,
                                        currentPlay: payload.currentPlay
                                    });
                                }
                                else {
                                    Toast.fail({
                                        message: res.data.describe,
                                        forbidClick: true,
                                        duration: 1500
                                    });
                                }
                            }
                            else {
                                Toast.fail({
                                    message: res.message,
                                    forbidClick: true,
                                    duration: 1500
                                });
                            }
                        });
                    }
                }
            }
        });
    },
    async openOrder({ commit, state, dispatch, rootState }, payload) {
        const { cookieId } = payload;
        let videoInstance = null;
        let currentPlay = false;
        if (payload) {
            videoInstance = payload.video;
            currentPlay = !!payload.currentPlay;
        }
        // H5 计费下单发起接口（一键开户）
        dispatch('handleActionApi', {
            isp: CarrierType.ENUM[CarrierType.TELECOM],
            token: rootState.app.userInfo.TOKEN,
            phone: rootState.app.userInfo.phone,
            action: '28',
            interfaceName: '/openPorTal',
            resCode: '',
            resMessage: ''
        });
        dispatch('handleActionApi', {
            isp: CarrierType.ENUM[CarrierType.TELECOM],
            token: rootState.app.userInfo.TOKEN,
            phone: rootState.app.userInfo.phone,
            action: '28',
            interfaceName: '设置id' + state.settingData.videoId,
            resCode: '',
            resMessage: ''
        });
        dispatch('checkMobileTrack', { type: '28', res: '', isSuccess: false, carrierName: CarrierType.TELECOM });
        // sdk订购
        const isLogin = rootState.app.loginStatus;
        const { token } = await dispatch('user/getUserToken', { phone: state.phone, type: CarrierType.TELECOM, isCommit: isLogin }, { root: true });
        const sdkKey = 'YzqnS6cbXFHHMcdJheUV2x72BD3d0BmE';
        window.iPayCallback = function (res) {
            const { code } = res;
            // 0000-业务受理成功
            // 0001-业务受理失败
            // 0002-用户取消订购
            dispatch('checkMobileTrack', {
                type: '32',
                res: JSON.stringify(res),
                isSuccess: res.code === '0000',
                carrierName: CarrierType.TELECOM
            });
            dispatch('handleActionApi', {
                isp: CarrierType.ENUM[CarrierType.TELECOM],
                token: token,
                phone: state.phone,
                action: '32',
                interfaceName: '/iPayCallback',
                resCode: res.code,
                resMessage: JSON.stringify(res)
            });
            switch (code) {
                case '0000': {
                    Toast.success('业务受理成功!');
                    break;
                }
                case '0001': {
                    Toast.fail('业务受理失败');
                    break;
                }
                case '0002': {
                    Toast.fail('用户取消订购');
                    commit('SET_HAS_CANCEL_ORDER', true);
                    const temData = JSON.parse(JSON.stringify(state.settingData));
                    commit('SET_RETENTION_ORDER_PARAMS', { ...temData, sourceType: state.carrierType, phone: state.phone });
                    break;
                }
            }
            console.log('支付回调', code);
        };
        const { categoryId, topicId, searchkey, pageid, cardid, pcid } = parseUrlParams(location.href);
        let channelDetail = '';
        // 判断三个渠道 主题、栏目、搜索
        if (categoryId) {
            channelDetail = 'categoryId-' + categoryId;
        }
        else if (topicId) {
            channelDetail = 'topicId-' + topicId;
        }
        else if (searchkey) {
            channelDetail = 'searchkey-' + encodeURIComponent(searchkey);
        }
        else if (pageid && cardid) {
            channelDetail = 'pageid-' + pageid + '-cardid-' + cardid;
        }
        if (!window.isInit) {
            window.imusicSdk.init(sdkKey, async (res) => {
                // H5 计费下单发起接口（一键开户）
                dispatch('handleActionApi', {
                    isp: CarrierType.ENUM[CarrierType.TELECOM],
                    token: rootState.app.userInfo.TOKEN,
                    phone: rootState.app.userInfo.phone,
                    action: '40',
                    interfaceName: '/init',
                    resCode: '',
                    resMessage: ''
                });
                console.log(res, '合作方收到init成功回调');
                window.isInit = true;
                const data = {
                    sdk_key: sdkKey,
                    token,
                    mobile: state.phone,
                    external_trade_id: `${pcid ?? ''}` + '_' + state.settingData.videoId + '_' + channelDetail,
                    product_id: state.settingData.productId,
                    page_color: '#FF1401',
                    remark: '' // 备注
                };
                const cb = (res) => {
                    dispatch('checkMobileTrack', {
                        type: '29',
                        res: res,
                        isSuccess: res.code === '0000',
                        carrierName: CarrierType.TELECOM
                    });
                    dispatch('handleActionApi', {
                        isp: CarrierType.ENUM[CarrierType.TELECOM],
                        token: rootState.app.userInfo.TOKEN,
                        phone: rootState.app.userInfo.phone,
                        action: '29',
                        interfaceName: '/openPorTal',
                        resCode: res.code,
                        resMessage: JSON.stringify(res)
                    });
                    console.log('openPorTal cb', res, data);
                    if (res.code === '0000') {
                        window.imusicSdk.toPay();
                    }
                    else {
                        Toast.fail(res.message);
                        ProcessDialog.close();
                    }
                };
                // 开始订购
                console.log(data);
                // sourceApi.channelAdd({
                //   mobile: state.phone,
                //   type: ~~CarrierType.TELECOM,
                //   promotionChannel: Router.currentRoute.query.pcid, // 推广渠道
                //   pid: rootState.app.selfInfo['dev-pid'],
                //   uid: rootState.app.selfInfo.uid,
                //   cookieId: cookieId
                // })
                // Toast({
                //   type: 'loading',
                //   duration: 1500
                // })
                // ProcessDialog()
                Toast.clear();
                ProcessDialog();
                window.imusicSdk.openPorTal(data, cb);
                setTimeout(() => {
                    const div = window.document.querySelector('#imusicTag');
                    commit('SET_STATUSDIV', true);
                    handleMIGUClose(div, videoInstance, currentPlay, { commit, state, rootState });
                }, 200);
            });
        }
        else {
            const data = {
                sdk_key: sdkKey,
                token,
                mobile: state.phone,
                product_id: state.settingData.productId,
                external_trade_id: `${pcid ?? ''}` + '_' + state.settingData.videoId + '_' + channelDetail,
                page_color: '#FF1401',
                remark: '' // 备注
            };
            const cb = (res) => {
                dispatch('checkMobileTrack', {
                    type: '29',
                    res: res,
                    isSuccess: res.code === '0000',
                    carrierName: CarrierType.TELECOM
                });
                dispatch('handleActionApi', {
                    isp: CarrierType.ENUM[CarrierType.TELECOM],
                    token: rootState.app.userInfo.TOKEN,
                    phone: rootState.app.userInfo.phone,
                    action: '29',
                    interfaceName: '/openPorTal',
                    resCode: res.code,
                    resMessage: JSON.stringify(res)
                });
                console.log('openPorTal cb', res, data);
                if (res.code === '0000') {
                    window.imusicSdk.toPay();
                }
                else {
                    Toast.fail(res.message);
                    ProcessDialog.close();
                }
            };
            // 开始订购
            console.log(data);
            // sourceApi.channelAdd({
            //   mobile: state.phone,
            //   type: ~~CarrierType.TELECOM,
            //   promotionChannel: Router.currentRoute.query.pcid, // 推广渠道
            //   pid: rootState.app.selfInfo['dev-pid'],
            //   uid: rootState.app.selfInfo.uid,
            //   cookieId: cookieId
            // })
            Toast.clear();
            ProcessDialog();
            window.imusicSdk.openPorTal(data, cb);
            setTimeout(() => {
                const div = window.document.querySelector('#imusicTag');
                commit('SET_STATUSDIV', true);
                handleMIGUClose(div, videoInstance, currentPlay, { commit, state, rootState });
            }, 200);
        }
    },
    unSubProductTelecom(context, payload) {
        unsubscribeTelecom(payload)
            .then(res => {
            Toast.success(res.data);
        });
    }
};
